class AddVehicleController {
  constructor ($rootScope, $state, VehicleService, IdsService, ValidationRules, I18n) {
    'ngInject'
    this.$rootScope = $rootScope
    this.$state = $state
    this.I18n = I18n
    this.vehicleService = VehicleService
    this.idsService = IdsService
    this.validationRules = ValidationRules
    this.vehicle = {}

    // Init. proccessing value
    this.isProcessing = false
  }

  addVehicle () {
    this.isProcessing = true
    this.vehicle.vin = this.vehicle.vin.toUpperCase()
    return this.vehicleService.addVehicle(this.vehicle)
      .then(() => {
        this.vehicleService.getCurrentUserVehicles(false)
        .then(() => {
          this.isProcessing = false
          this.$rootScope.$broadcast('vehicles:update')
          this.idsService.encode(this.vehicle.vin)
          .then((svin) => {
            this.vehicleService.setCurrentSelectedVehicle(svin)
            .then(() => {
              return this.$state.go('profile.myGarage',
                {
                  vin: svin
                }
              )
            })
          })
        })
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-garage.addVehicleForm.error',
          cause: err
        }
      })
  }

}

export default AddVehicleController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/add-vehicle/add-vehicle.controller.js